import PropTypes from 'prop-types';
import React, { Component } from 'react';
import noop from 'lodash/noop';
import Checkbox from 'yoda-core-components/lib/components/CheckBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

class HighPriority extends Component {
    static propTypes = {
        ppId: PropTypes.string,
        containerClass: PropTypes.string,
        mostWanted: PropTypes.bool.isRequired,
        status: PropTypes.string,
        isSharedUser: PropTypes.bool,
        toggleCallback: PropTypes.func,
        guestCallback: PropTypes.func,
        listId: PropTypes.string.isRequired,
        asyncLoading: PropTypes.bool,
        productId: PropTypes.string.isRequired,
        label: PropTypes.string,
        isGuestMode: PropTypes.bool,
        isSharedMode: PropTypes.bool,
        authStatus: PropTypes.number,
    };

    static defaultProps = {
        status: '',
        isSharedUser: false,
        ppId: '',
        containerClass: '',
        toggleCallback: noop,
        guestCallback: noop,
        asyncLoading: false,
        label: 'High Priority',
        isGuestMode: false,
        isSharedMode: false,
        authStatus: 0,
    };

    toggleMostWantedStatus = (event) => {
        const { toggleCallback, isGuestMode, guestCallback, listId } = this.props;
        const isChecked = event.target.checked;
        if (isGuestMode) {
            guestCallback(isChecked);
        } else {
            toggleCallback(isChecked, listId);
        }
    };

    renderSharedUser() {
        const { label, mostWanted } = this.props;
        if (mostWanted) {
            return (
                <div
                    className={dt([
                        'text-base',
                        'text-black',
                        'text-right',
                        'smMd:text-xsmall',
                        'smMd:font-open-sans-bold',
                        'mdOnly:w-6/12',
                        'mdOnly:float-right',
                        'smOnly:relative',
                    ])}
                    data-automation-id="shareListLabel"
                >
                    {label}
                </div>
            );
        }
        return null;
    }

    renderHiPriorityCheckBox() {
        const { mostWanted, productId, label } = this.props;
        return (
            <Checkbox
                defaultChecked={!!mostWanted}
                id={`list-most-wanted-${productId}`}
                name="mostWantedCheckbox"
                label={label}
                onChange={this.toggleMostWantedStatus}
                automationId="product-card-mostWanted-checkbox"
            />
        );
    }

    renderGuestUser() {
        return (
            <div data-automation-id="highPriorityWrapper">{this.renderHiPriorityCheckBox()}</div>
        );
    }

    renderAuthUser() {
        const { asyncLoading } = this.props;
        return (
            <div data-automation-id="highPriorityWrapper">
                {this.renderHiPriorityCheckBox()}
                {asyncLoading && (
                    <div
                        className={dt(['absolute', 'top-0', 'left-0', 'right-0', 'bottom-0'])}
                        data-automation-id="asyncLoading"
                    />
                )}
            </div>
        );
    }

    render() {
        const { status, isSharedUser, isSharedMode, isGuestMode, authStatus } = this.props;

        // Todo: Whenever Lists-62 is completed we need to change
        // isSharedUser to supply correctly
        // 1. shared user logic
        if (isSharedMode) {
            return this.renderSharedUser();
        }

        if (isGuestMode) {
            return this.renderGuestUser();
        }
        // 2. auth user logic
        const isAuthUser = authStatus !== 0;
        const isInStock = ['SELECT_SKU_OPTIONS', 'ADD_TO_CART'].includes(status);
        // const isFavorites = (listId === 'myFavorites');
        if (!isSharedUser && isInStock && isAuthUser) {
            return this.renderAuthUser();
        }
        return null;
    }
}

export default HighPriority;
